export const BASE_CLASS = 'font-bold font-display lg:leading-tight'
export const titleClasses = {
  small: 'text-lg lg:text-3xl',
  default: 'text-xl lg:text-4xl',
  large: 'text-2xl lg:text-4xl',
  xl: 'text-3xl lg:text-5xl lg:leading-snug'
}
